import { lazy } from "react";

import {
  Dashboard as DashboardIcon,
  Transactions as TransactionsIcon,
  Company as CompanyIcon,
  Config as ConfigIcon,
} from "@volt_developers/react-ui-components";

import { administrationRoutes } from "./administration";
import { Route } from "./RouteModel";
import { configurationRoutes } from "./configuration";
import { applicationRoutes } from "./configuration/applications";
import customerRoutes from "./configuration/customers";
import { accountRoutes } from "./configuration/accounts";
import { userRoutes } from "./configuration/users";

const Login = lazy(() => import("../pages/Login"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const TransactionList = lazy(() => import("../pages/transactions/List"));
const TransactionDetails = lazy(() => import("../pages/transactions/Details"));
const CompanyDetails = lazy(() => import("../pages/company/Details"));

const homeRoutes: Route = {
  i18nName: "Dashboard",
  path: "/",
  icon: DashboardIcon,
  component: Dashboard,
  newTheme: true,
  can: {
    do: "list",
    on: "payment",
  },
};

const transactionRoutes: Route = {
  i18nName: "Transactions",
  path: "/transactions",
  newTheme: true,
  icon: TransactionsIcon,
  component: TransactionList,
  showChildrenInSidebar: false,
  can: {
    do: "list",
    on: "payment",
  },
  children: [
    {
      path: "/transactions/:id",
      i18nName: "Transaction",
      newTheme: true,
      component: TransactionDetails,
      can: {
        do: "details",
        on: "payment",
      },
    },
  ],
};

const companyRoutes: Route = {
  i18nName: "Company",
  path: "/company",
  icon: CompanyIcon,
  showChildrenInSidebar: true,
  can: {
    do: "details",
    on: "customer",
  },
  children: [
    {
      path: "/company/details",
      i18nName: "Details",
      component: CompanyDetails,
      can: {
        do: "details",
        on: "customer",
      },
    },
  ],
};

export const auth: Route[] = [
  {
    i18nName: "Login",
    path: "/login",
    component: Login,
  },
];

export const portal: Route[] = [
  homeRoutes,
  transactionRoutes,
  configurationRoutes,
  companyRoutes,
  administrationRoutes,
];

export const portalMVP: Route[] = [
  homeRoutes,
  transactionRoutes,
  {
    i18nName: "Configuration",
    path: "/configuration",
    icon: ConfigIcon,
    showChildrenInSidebar: true,
    can: {
      do: "list",
      on: "account",
    },
    children: [accountRoutes, applicationRoutes, customerRoutes, userRoutes],
  },
  administrationRoutes,
  // ...(process.env.REACT_APP_ENV !== "production" ? [administrationRoutes] : []),
];

const appRoutes = ["prod", "rc"].includes(process.env.REACT_APP_ENV || "")
  ? portalMVP
  : portal;

export default appRoutes;
